export default "__VITE_ASSET__COi7xwQ___"